// extracted by mini-css-extract-plugin
export default {"delete":"T9khEcFD","x":"b6xrQD8d"};